import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm md:text-base font-semibold tracking-wide uppercase transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-brand-gold text-brand-charcoal hover:bg-[#b39154] hover:shadow-lg hover:shadow-brand-gold/20 focus:ring-brand-gold',
    secondary: 'bg-transparent border-2 border-brand-teal text-brand-teal hover:bg-brand-teal hover:text-brand-cream focus:ring-brand-teal'
  };
  if (href) {
    const isExternal = href.startsWith('http');
    return <motion.a href={href} onClick={onClick} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-151">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-152">
      {children}
    </motion.button>;
}